import { $robotoFontFamily } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { colorsPalettes, rgba } from "@similarweb/styles";
import styled from "styled-components";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: "20px 24px 16px 24px", width: 562, border: 0 },
    overlay: {
        backgroundColor: rgba(colorsPalettes.midnight["300"], 0.7),
    },
};

export const StyledDD = styled.div`
    position: relative;
    width: auto;

    & .country-text {
        ${setFont({ $color: colorsPalettes.carbon["500"], $size: 14 })};
    }
`;

export const StyledModalSubTitle = styled.div`
    ${setFont({
        $size: 16,
        $weight: 400,
        $family: $robotoFontFamily,
        $color: colorsPalettes.carbon[400],
    })};
    line-height: 20px;
    margin-bottom: 12px;
`;

export const StyledWrapperPlainTooltip = styled.div`
    position: relative;
    cursor: pointer;

    .PlainTooltip-element {
        width: 500px;
    }
`;
